import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PaFileMetadata } from '@pa-angular/pa-file-metadata';
import { lastValueFrom } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileMetaDataEnvService {
  confidentialFilesMetadata: PaFileMetadata[] = [];
  existingFilesMetadata: PaFileMetadata[] = [];
  allowUnclassifiedFilesUpload: boolean = true;

  constructor(private http: HttpClient) { }

  async loadEnvFile(): Promise<void> {
    try {
      const envData: any = await lastValueFrom(
        this.http.get('/assets/env/env.json')
      );

      this.confidentialFilesMetadata = this.getParsedMetadata(
        environment['CONFIDENTIAL_FILES_METADATA'] || ''
      );
      this.existingFilesMetadata = this.getParsedMetadata(
        environment['EXISTING_FILES_METADATA'] || ''
      );
      this.allowUnclassifiedFilesUpload = environment['CONFIDENTIAL_FILES_ALLOW_UNCLASSIFIED'];
    } catch (error) {
      console.error('Failed to load env.json:', error);
      throw error;
    }
  }

  private getParsedMetadata(metadataString: string): PaFileMetadata[] {
    const fileMetadata: PaFileMetadata[] = [];
    if (metadataString.length) {
      metadataString.split(',').forEach((keyValue: string) => {
        const [propName, propValue] = keyValue.split('=');
        if (!propName || !propValue) {
          throw new Error(
            'Metadata structure is invalid! Expected format: "key1=value1,key2=value2"'
          );
        }
        fileMetadata.push({ propName, propValue });
      });
    }
    return fileMetadata;
  }

}
